import { Group } from './group.model';
import { UserModel } from './userModel';

export class GroupUser {
    id:number;
    group:Group;
    systemUser:UserModel;
    version:number;
}